/**
 * Date string matching PUBSUB_CREATED_FORMAT (Django): YYYY/MM/DD, HH:MM:SS
 */
export function formatPubSubDate(date = new Date()) {
  const d = date instanceof Date ? date : new Date(date);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())}, ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

/** HTTP 402 — insufficient credits (check on RTK Query `unwrap()` error object). */
export function isInsufficientCreditsError(error) {
  if (!error || typeof error !== 'object') return false;
  const status = error.status ?? error.originalStatus;
  return status === 402;
}
